
<template>
  <div class="form_group">
    <label>
      {{ label }} <small v-if="favoriteAddress"><a href="" class="accent--text" @click.prevent="getFavoriteAddress">({{ $t(`${namespace}.form.favoriteAddress`) }})</a></small>
    </label>
    <input
      :ref="kind"
      :placeholder="placeholder"
      autocomplete="off"
      class="input--custom"
      :class="hasError ? 'input--invalid' : ''"
      :v-validate="vValidate"
      :data-vv-name="dataVvName"
      :error-messages="errorMessages"
      @input="handleInput"
      @blur="handleBlur"
      @focus="handleInitAutocomplete"
    />
    <transition name="invalid-feedback">
      <span v-if="hasError" class="invalid-feedback">
        {{ errorMessages[0] }}
      </span>
    </transition>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { isArray } from 'utils/functions'

export default {
  name: 'LocationAutocomplete',
  props: {
    kind: {
      type: String
    },
    modelValue: {
      type: String
    },
    label: {
      type: String
    },
    placeholder: {
      type: String
    },
    dataVvName: {
      type: String
    },
    vValidate: {
      type: undefined
    },
    errorMessages: {
      type: [Object, Array]
    },
    favoriteAddress: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState({
      webcallMoveMarkersToggle: ({ webcallMoveMarkers }) => webcallMoveMarkers.toggle
    }),

    value: {
      get () {
        return this.modelValue
      },
      set (value) {
        this.$emit('update:modelValue', value)
      }
    },
    hasError () {
      return isArray(this.errorMessages) ? this.errorMessages[0] : null
    }
  },
  data () {
    return {
      namespace: 'Views.NewWebCallPage'
    }
  },
  methods: {
    handleInput ($event) {
      this.$emit('update:modelValue', $event.target.value)
    },

    handleInitAutocomplete () {
      const $input = this.$refs[this.kind]
      $input && this.$gmaps.initAutocomplete($input, this.kind)
    },

    handleRenderMarkers () {
      setTimeout(() => {
        const { originPosition, destinyPosition } = this.$gmaps.getPositions()

        if (originPosition && destinyPosition) {
          this.$gmaps.renderMarkers({})
          this.$emit('hideMapOverlay')
        }
      }, 1000)
    },

    updateOriginAndDestiny () {
      const { originPosition, destinyPosition } = this.$gmaps.getPositions()
      const $ref = this.$refs[this.kind]

      if (this.kind === 'origin' && originPosition && originPosition.address) {
        $ref.value = originPosition.address
      }

      if (this.kind === 'destiny' && destinyPosition && destinyPosition.address) {
        $ref.value = destinyPosition.address
      }
    },

    handleBlur ($event) {
      this.handleInput($event)
      this.handleRenderMarkers()
    },

    getFavoriteAddress () {
      this.$emit('getFavoriteAddress', this.kind)
    }
  },
  watch: {
    webcallMoveMarkersToggle () {
      this.updateOriginAndDestiny()
    }
  }
}
</script>

<style lang="scss" scoped>
.form_group {
  padding-bottom: 25px;
  position: relative;

  .invalid-feedback {
    bottom: 9px;
    color: $error;
    font-size: 10px;
    left: 0;
    position: absolute;
    right: 0;
  }
}

.input--custom {
  align-items: stretch;
  background-color: #fff;
  border: 1px solid #d6d6d6;
  border-radius: 2px;
  display: block;
  font-size: 14px;
  min-height: 56px;
  outline: none;
  padding: 0 12px;
  transition: border .26s;
  width: 100%;

  &:focus {
    border-color: $accent;
  }

  &.input--invalid {
    border-color: $error;
  }
}
</style>
